// src/pages/LoginPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Pill, Loader2 } from 'lucide-react';
import '../styles/pages.css';

const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      navigate(user.roles?.includes('admin') ? '/admin' : '/calculator');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="login-logo-icon"><Pill size={32} /></div>
          <div>
            <h1>MediDose</h1>
            <p>Clinical Decision Support</p>
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && <div className="login-error">{error}</div>}

          <div className="form-group">
            <label className="form-label required">Email Address</label>
            <input
              className="form-input"
              type="email"
              name="email"
              placeholder="doctor@hospital.com"
              value={form.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label required">Password</label>
            <input
              className="form-input"
              type="password"
              name="password"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <button className="btn btn-primary login-btn" type="submit" disabled={loading} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {loading ? <><Loader2 className="spinner" size={16} style={{ marginRight: 6 }} /> Signing in…</> : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p style={{ color: '#94a3b8', fontSize: '0.875rem', margin: 0 }}>
            &copy; {new Date().getFullYear()} MediDose Inc. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
